export default "__VITE_ASSET__xnxaxiTZ__"